// English (en) — 完整翻译模板，其他语言基于它派生

export const en = {
  brand: {
    name: 'DoneLine',
    tagline: 'A focused personal project manager',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    rename: 'Rename',
    archive: 'Archive',
    add: 'Add',
    close: 'Close',
    edit: 'Edit',
    new: 'New',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    skip: 'Skip',
    done: 'Done',
    loading: 'Loading…',
    sending: 'Sending…',
    saving: 'Saving…',
    untitled: 'Untitled',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    none: 'None',
    optional: 'Optional',
    requiredField: 'Required',
    confirmDelete: 'Confirm delete?',
  },
  nav: {
    today: 'Today',
    upcoming: 'Upcoming',
    inbox: 'Inbox',
    projects: 'My Projects',
    tags: 'Tags',
    reports: 'Weekly Report',
    settings: 'Settings',
    quickCapture: 'Quick Add',
    search: 'Search',
    newProject: 'New Project',
    addSection: 'Add Section',
    openMenu: 'Open menu',
  },
  search: {
    title: 'Search',
    placeholder: 'Search tasks, projects, tags…',
    noResults: 'No results',
    tasks: 'Tasks',
    projects: 'Projects',
    tags: 'Tags',
  },
  today: {
    title: 'Today',
    eyebrow: 'Today',
    overdue: 'Overdue',
    today: 'Today',
    completed: 'Completed',
    empty: 'Nothing scheduled today. Take a breath ☕',
    summary: '{active} pending · {done} completed',
    reschedule: 'Reschedule',
    rescheduled: '{count} task(s) rescheduled',
  },
  inbox: {
    title: 'Inbox',
    eyebrow: 'Inbox',
    empty: 'Inbox is empty.',
    pending: '{count} pending',
  },
  upcoming: {
    title: 'Upcoming',
    eyebrow: 'Next 7 days',
    todayLabel: 'Today',
    tomorrowLabel: 'Tomorrow',
    empty: 'No tasks in the next 7 days.',
  },
  project: {
    eyebrow: 'Project',
    notFound: 'Project not found',
    notFoundHint: 'It may have been deleted or archived.',
    inProgress: '{count} in progress',
    completed: '{count} completed',
    ungrouped: 'Ungrouped',
    addSection: 'Add Section',
    listView: 'List',
    ganttView: 'Gantt',
    ganttZoomIn: 'Zoom in',
    ganttZoomOut: 'Zoom out',
    ganttWide: 'Wide',
    ganttCompact: 'Compact',
    empty: 'No tasks in this project yet',
    emptyHint: 'Use the input above to add one.',
    sectionEmpty: '— No tasks —',
    completedSection: 'Completed',
    newSectionTitle: 'New Section',
    newSectionPlaceholder: 'Section name',
    renameProjectTitle: 'Rename Project',
    renameProjectPlaceholder: 'Project name',
    editProjectTitle: 'Edit Project',
    color: 'Color',
    icon: 'Icon',
    noIcon: 'No icon',
    deleteProjectTitle: 'Delete project "{name}"?',
    deleteProjectDesc: 'Tasks in this project will be moved to Inbox. This cannot be undone.',
    archiveProject: 'Archive',
    actionsMenu: 'Project actions',
    renameSectionTitle: 'Rename Section',
    sectionDeleteTitle: 'Delete section "{name}"?',
    sectionDeleteDesc: 'Tasks in this section move to the project root. This cannot be undone.',
    sectionActionsMenu: 'Section actions',
    sectionReorder: 'Reorder section',
    descriptionPlaceholder: 'Add a note about this project…',
    descriptionEditHint: 'Markdown supported · ⌘↵ to save · Esc to close',
    descriptionEmpty: 'Click to add a note',
  },
  reports: {
    eyebrow: 'Weekly Report',
    title: 'Last 7 days',
    serverGeneratedAt: 'Generated by server at {time}',
    syncingFromServer: 'Syncing from server…',
    computedLocally: 'Computed locally',
    aiSummary: 'AI Weekly Summary',
    completedCount: 'Completed',
    completionRate: 'Completion rate',
    overdueCount: 'Overdue',
    dailyAverage: 'Daily avg',
    dailyCompleted: 'Daily completed',
    dailyCompletedAxis: '(tasks)',
    byProject: 'By Project',
    noCompletedThisWeek: 'No tasks completed this week.',
    serverNotReady:
      "Server hasn't generated this week's report yet. The batch worker runs every Monday at 09:00 in your timezone.",
  },
  upgrade: {
    title: 'Upgrade to DoneLine Pro',
    featureLocked: '{feature} is a Pro feature.',
    comingSoon: 'Pro plans launch soon — your account will be ready then.',
    signInFirst: 'Sign in to upgrade',
    benefits: {
      unlimitedProjects: 'Unlimited projects (free is capped at 3)',
      history: '365-day modification history (free is 7 days)',
      gantt: 'Gantt timeline view',
      importExport: 'Import / export your data',
      themes: 'More themes including Paper',
    },
    feature: {
      projects: 'More than 3 projects',
      gantt: 'Gantt view',
      importExport: 'Import / Export',
      paperTheme: 'Pro themes',
    },
    cta: {
      stripe: 'Subscribe — $2.99/mo or $29.99/yr',
      apple: 'Subscribe via Apple',
      google: 'Subscribe via Google Play',
    },
  },
  plan: {
    title: 'Plan',
    description: 'Your subscription tier.',
    free: 'Free',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: 'Upgrade to Pro',
    devSwitchHint: 'Preview: temporarily switch plan to see gating in action',
    switchToFree: 'Switch to Free (preview)',
    switchToPro: 'Switch to Pro (preview)',
  },
  settings: {
    display: {
      title: 'Display',
      description: 'Choose which details task lists show inline.',
      tags: 'Tags',
      tagsHint: 'Show tag chips on task rows',
      descriptionLabel: 'Description',
      descriptionHint: 'Show a one-line description preview',
      subtasks: 'Sub-tasks',
      subtasksHint: 'Show sub-task progress and expanders',
    },
    eyebrow: 'Settings',
    title: 'Preferences',
    appearance: {
      title: 'Appearance',
      description: 'Choose the theme that fits the moment.',
    },
    language: {
      title: 'Language',
      description: 'Display language for menus and labels.',
    },
    desktop: {
      title: 'Desktop',
      description:
        'Native macOS / Windows / Linux behaviour. Only takes effect when running the desktop app.',
      alwaysOnTopLabel: 'Always on top',
      alwaysOnTopHint: 'Keep the window above all other apps until toggled off.',
      globalHotkeyLabel: 'Global quick-capture shortcut',
      globalHotkeyHint:
        'System-wide ⌘⇧Space — opens DoneLine and focuses the capture box from anywhere.',
    },
    account: {
      title: 'Account',
      description: 'Sign-in info and quick stats.',
      summary: '{tasks} tasks · {projects} projects',
      signOut: 'Sign out',
      deleteAccount: 'Delete account',
      deleteAccountConfirmTitle: 'Delete account?',
      deleteAccountConfirmBody:
        'This permanently deletes your account and every task, project and tag on our servers and in this browser. This cannot be undone. Export your data first if you want to keep it.',
      deleteAccountConfirm: 'Delete',
      deleteAccountFailed: 'Could not delete your account',
      signingOut: 'Signing out…',
      notSignedIn: 'Not signed in',
      signInCta: 'Sign in',
      guestHint:
        'Guest mode: data stays on this device. Sign in to enable sync and back up your tasks.',
      displayNameLabel: 'Display name',
      displayNamePlaceholder: 'Your name',
      displayNameSaved: 'Saved',
      displayNameSaveFailed: 'Failed to save',
      avatarLabel: 'Avatar',
      avatarHint: 'JPG, PNG, WEBP or GIF, up to 2 MB. Falls back to your initial when empty.',
      avatarUpload: 'Upload picture',
      avatarChange: 'Change picture',
      avatarUploading: 'Uploading…',
      avatarRemove: 'Remove',
      avatarSaved: 'Avatar updated',
      avatarSaveFailed: 'Failed to update avatar',
      avatarErrorType: 'Unsupported image type. Use JPG, PNG, WEBP or GIF.',
      avatarErrorSize: 'Image is too large. Max 2 MB.',
    },
    sync: {
      title: 'Sync',
      description: 'Run a full incremental pull right now.',
      forceSync: 'Force Sync Now',
      syncing: 'Syncing…',
      done: 'Sync complete',
    },
    shortcuts: {
      title: 'Keyboard Shortcuts',
      description: 'The keyboard is the fastest pointer.',
      view: 'View Shortcuts',
    },
    data: {
      title: 'Data',
      description: 'All data is stored locally first, then synced.',
      export: 'Export JSON',
      import: 'Import JSON',
      exportDone: 'Exported {n} tasks',
      importDone: 'Imported {n} new items',
      importError: 'Import failed: {error}',
      importPersistFailed:
        "Import couldn't be saved to local storage — the data may exceed this device's storage limit. Try importing in smaller batches.",
      clearAll: 'Clear local data',
      clearConfirmTitle: 'Clear all local data?',
      clearConfirmDesc:
        'This removes everything stored in this browser. Synced data on the server is not affected. The page will reload.',
      cleared: 'Cleared. Reloading…',
    },
    about: {
      title: 'About',
      version: 'Version {v}',
      description: 'A GTD-inspired personal todo & project manager.',
    },
  },
  guest: {
    banner: 'Guest mode — data stays on this device only. Sign in to sync across devices.',
    bannerCta: 'Sign in',
    emptyHint: 'Your data stays on this device until you sign in. Add your first task below.',
    storageWarning:
      'Guest data lives only in this browser and may be cleared by the system. Sign in or export regularly to keep it safe. Exports are unencrypted files.',
  },
  login: {
    welcomeBack: 'Welcome back',
    helperSupabase: "Enter your email and we'll send a one-time sign-in link.",
    helperLocal:
      'Local-only mode: enter any email to sign in instantly. Data stays on this device.',
    emailPlaceholder: 'you@example.com',
    sendLink: 'Send sign-in link',
    sendingLink: 'Sending…',
    sentSupabase: 'Sent to {email}. Click the link in your inbox to sign in.',
    otpPrompt: 'Or enter the code from the email',
    otpPlaceholder: '6-digit code',
    otpSubmit: 'Sign in',
    otpFailed: 'That code is not valid or has expired',
    sentLocal: 'Signed in as {email}. Loading…',
    modeSupabase: 'Supabase Auth',
    modeLocal: 'Local-only mode',
    skipGuest: 'Skip for now — use locally',
    skipFailed: 'Could not enable guest mode (storage write failed). Please try again.',
    merge: {
      title: 'You have {count} tasks on this device',
      keep: 'Merge them into my account',
      irreversible: 'They will be uploaded after sign-in. Merging cannot be undone.',
      discard: "Don't keep local data — sign in fresh",
      discardConfirmTitle: '{count} local tasks will be deleted after sign-in',
      discardConfirmBody:
        'After you sign in, the {count} tasks on this device will be permanently deleted and cannot be recovered. Continue?',
    },
    error: 'Sign-in failed',
  },
  task: {
    recurringAdvanced: 'Recurring — moved to {date}',
    recurringFinished: 'Recurrence ended — task completed',
    titlePlaceholder: 'Task title',
    description: 'Description',
    descriptionPlaceholder: 'Add a description…',
    descriptionEmpty: 'No description.',
    descriptionEdit: 'Edit description',
    descriptionSave: 'Save description',
    descriptionCancel: 'Cancel',
    save: 'Save',
    saved: 'Saved',
    discardConfirmTitle: 'Discard unsaved changes?',
    discardConfirmDesc: 'You have unsaved edits. Closing now will lose them.',
    priority: 'Priority',
    date: 'Date',
    project: 'Project',
    section: 'Section',
    parentTask: 'Parent',
    tags: 'Tags',
    subtasks: 'Subtasks',
    expandSubtasks: 'Expand subtasks',
    collapseSubtasks: 'Collapse subtasks',
    addSubtaskPlaceholder: '+ Add subtask',
    comments: 'Comments',
    noComments: 'No comments yet',
    commentPlaceholder: 'Write a comment…',
    sendComment: 'Send',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete this task?',
    deleteConfirmDesc: 'Subtasks will be deleted with it.',
    saveHint: '⌘/Ctrl + Enter to save & close',
    open: 'Open',
    completed: 'Completed',
    markComplete: 'Mark complete',
    markIncomplete: 'Mark incomplete',
    moreActions: 'More actions',
  },
  priority: {
    high: 'High',
    mid: 'Medium',
    low: 'Low',
    none: 'None',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: 'Single Day',
      datetime: 'Time',
      range: 'Date Range',
      today: 'Today',
      tomorrow: 'Tomorrow',
      thisWeekend: 'This weekend',
      nextWeek: 'Next week',
      noDate: 'No date',
    },
    overdue: 'Overdue',
    notScheduled: 'No date set',
  },
  recurrence: {
    title: 'Repeat',
    none: "Doesn't repeat",
    custom: 'Custom…',
    applyCustom: 'Apply custom rule',
    end: 'End repeat',
    preset: {
      daily: 'Daily',
      weekdays: 'Every weekday',
      weekly: 'Weekly',
      biweekly: 'Every 2 weeks',
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
    summary: {
      daily: 'Daily',
      everyNDays: 'Every {n} days',
      weekly: 'Weekly',
      everyNWeeks: 'Every {n} weeks',
      weeklyOn: 'Weekly on {days}',
      everyNWeeksOn: 'Every {n} weeks on {days}',
      monthly: 'Monthly',
      everyNMonths: 'Every {n} months',
      yearly: 'Yearly',
      everyNYears: 'Every {n} years',
    },
    weekday: { sun: 'Sun', mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat' },
    freq: { daily: 'Day(s)', weekly: 'Week(s)', monthly: 'Month(s)', yearly: 'Year(s)' },
    every: 'Every',
  },
  aiUsage: {
    title: 'AI usage',
    planFree: 'Free plan',
    planPro: 'Pro plan',
    planProAi: 'Pro AI plan',
    usedOf: '{used} / {limit} this month',
    remaining: 'Remaining: {count}',
    resetsMonthly: 'Resets on the 1st of each month (UTC)',
    history: 'Recent activity',
    historyEmpty: 'No AI usage yet',
    endpointParse: 'AI parsing',
    endpointBreakdown: 'AI breakdown',
    signInFirst: 'Sign in to view your AI usage',
    loadFailed: 'Could not load usage',
    retry: 'Retry',
  },
  parseTask: {
    mode: 'AI',
    quickMode: 'Quick',
    title: 'AI Task Parsing',
    placeholder: 'Describe a task in your own words…',
    titlePlaceholder: 'Task title',
    hint: 'AI fills in date, priority, project & tags',
    parse: 'Parse',
    confirm: 'Add task',
    confirmMany: 'Add {count} tasks',
    back: 'Back',
    voice: 'Voice input',
    voiceDenied: 'Microphone permission denied',
    voiceUnavailable: 'Voice input not supported in this browser',
    errors: {
      rateLimited: 'Too many requests — try again shortly',
      monthlyLimit: 'Monthly AI quota used up — upgrade for more',
      unauthorized: 'Please sign in to use AI',
      unavailable: 'AI is currently unavailable',
      failed: 'Could not parse the task — try rephrasing',
    },
  },
  quickCapture: {
    placeholder: 'Add a task… (Press Enter to save)',
    hint: 'Try: "Buy milk tomorrow @life/groceries #quick p2"',
    newTag: '#{name} (new)',
    dismissMatch: 'Keep "{label}" as text',
    createTag: 'Create tag "{name}"',
    syntaxCheatsheet: 'today / tomorrow / next mon · @project[/section] · #tag · p1-p4',
    add: 'Add',
    open: 'Open Quick Add',
    addTask: 'Add task',
  },
  tag: {
    eyebrow: 'Tag',
    editTagTitle: 'Edit tag',
    renameTagPlaceholder: 'Tag name',
    newTagPlaceholder: 'New tag…',
    deleteTagTitle: 'Delete tag "{name}"?',
    deleteTagDesc: 'It will be removed from {count} task(s). This cannot be undone.',
    actionsMenu: 'Tag actions',
    nameTaken: 'A tag with this name already exists',
    empty: 'No tasks with this tag',
  },
  quickbar: {
    signInRequired: 'Sign in required',
    signInHint: 'Sign in first to capture tasks from the menu bar.',
    signInOpenMain: 'Open the DoneLine main window to sign in',
  },
  sync: {
    idle: 'Synced',
    syncing: 'Syncing',
    offline: 'Offline',
    error: 'Sync failed',
    disabled: 'Local mode',
    pending: '{count} pending',
    syncingPending: 'Syncing · {count} pending',
    offlinePending: 'Offline · {count} pending',
    authError: 'Auth failed — please sign in again',
    rejectedBatch: 'Data validation failed — some changes were dropped',
    retry: 'Click to retry',
  },
  commandPalette: {
    placeholder: 'Search tasks, jump to a view, or run an action…',
    empty: 'No matches.',
    tasks: 'Tasks',
    projects: 'Projects',
    navigation: 'Navigation',
    actions: 'Actions',
  },
  bulk: {
    toolbar: 'Bulk actions',
    selected: '{count} selected',
    clear: 'Clear',
    deleteTitle: 'Delete {count} task(s)?',
    deleteDesc: 'Subtasks will be deleted with them. This cannot be undone.',
    mixedProjects: 'Mixed projects',
  },
  shortcuts: {
    title: 'Keyboard Shortcuts',
    quickAdd: 'Quick Add',
    search: 'Search',
    help: 'Show this',
    gotoToday: 'Go to Today',
    gotoInbox: 'Go to Inbox',
    gotoUpcoming: 'Go to Upcoming',
    drawer: {
      title: 'In Task Detail',
      saveClose: 'Save and close',
      delete: 'Delete task',
      priorityKeys: 'Set priority (1=High … 4=None)',
    },
  },
  welcome: {
    title: 'Welcome to {brand}',
    subtitle: "Let's get you started in 30 seconds.",
    step1: {
      title: 'Capture anything in 1 second',
      body: 'Press Q anywhere to open Quick Add. Type a task and press Enter — it goes straight to your Inbox.',
    },
    step2: {
      title: 'Organize when you have time',
      body: 'Drag tasks into Projects and Sections. Add a date, priority, or tags later when you decide.',
    },
    step3: {
      title: 'Plan your day',
      body: 'The Today view automatically gathers everything due today and ongoing date ranges.',
    },
    step4: {
      title: "You're set",
      body: "We've added a few starter tasks to help you explore. Mark them done or delete them anytime.",
    },
    getStarted: 'Get Started',
  },
  onboarding: {
    project: {
      welcome: 'Welcome',
      learn: 'Learn',
    },
    tasks: {
      welcome: '👋 Welcome to {brand}!',
      welcomeDesc:
        "Click the checkbox to your left to mark this done. That's how you complete a task.",
      quickAdd: '⚡ Try Quick Add: press Q or click the button in the top-left',
      quickAddDesc:
        'Type a task title and press Enter. You can add it to a project with @project, tag with #tag, set priority with p1-p4.',
      organize: '📁 Group related tasks into Projects',
      organizeDesc: "Click '+ New Project' in the sidebar to create one. Drag tasks into it.",
      schedule: '🗓 Set a date to plan ahead',
      scheduleDesc:
        'Tasks scheduled today appear in the Today view. Try opening this task and giving it a due date.',
      priority: '🔥 Use priorities (P1=High, P4=None)',
      priorityDesc: 'Press 1 / 2 / 3 / 4 in the task drawer to set priority quickly.',
      drag: '✋ Drag to reorder',
      dragDesc: 'Hover a task and use the grip icon on the left to drag it to a new position.',
      gantt: '📊 Visualize with Gantt chart',
      ganttDesc: 'Open any project and switch to "Gantt" tab to see tasks on a timeline.',
      reports: '📈 Reflect with Weekly Report',
      reportsDesc: 'See what you completed and what got carried over each week.',
      finishMe: "✅ Mark this checklist done — you're ready!",
    },
  },
  errors: {
    networkError: 'Network error',
    unknownError: 'Unknown error',
    notFound: 'Not found',
    pageNotFound: 'Page not found',
    pageNotFoundDesc: "This URL doesn't exist or has moved.",
    backHome: 'Back to Today',
    somethingWrong: 'Something went wrong',
    tryAgain: 'Try again',
    goHome: 'Go home',
  },
  theme: {
    light: 'Light',
    dark: 'Dark',
    paper: 'Paper',
    rose: 'Rose',
    lavender: 'Lavender',
    peach: 'Peach',
    mauve: 'Mauve',
    slate: 'Slate',
    forest: 'Forest',
    midnight: 'Midnight',
    shiba: 'Shiba',
    cat: 'Cat',
    ocean: 'Ocean',
    sky: 'Sky',
    mint: 'Mint',
    matcha: 'Matcha',
    amber: 'Amber',
    mocha: 'Mocha',
    crimson: 'Crimson',
    nord: 'Nord',
    dracula: 'Dracula',
    graphite: 'Graphite',
    system: 'System',
    pickerTitle: 'Theme',
  },
} as const;

export type TranslationShape = typeof en;
